/* @flow */

import React from 'react';
import _ from 'lodash';
// import cx from 'classnames';
import { Col, InputGroup, Input } from 'reactstrap';

// import classes from './FieldTypeInput.scss';
import { createHTMLMarkup, branch } from '../../utils';
import RevertInput from '../RevertInput';

import fieldWrapperClases from '../FieldWrapper/FieldWrapper.scss';

type PropsType = {
  calculated: ?boolean,
  changed: boolean,
  changeInput: Function,
  defaultVal: number | string,
  error: string[],
  range: [number, number],
  revertInput: Function,
  step: string,
  type: string,
  unit: ?string,
  value: number | string,
};

export class FieldTypeInput extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    range: [1, 2],
    error: [],
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const {
      error, defaultVal, value, changed,
      range, type, calculated, unit, step,
      revertInput, changeInput,
    } = this.props;
    const canRevert = changed || value !== defaultVal;

    const rangeDiv = (
      <button disabled className="btn btn-link btn-sm disabled" style={{ cursor: 'inherit' }}>
        {`Range: [${range[0]}, ${range[1]}]`}
      </button>
    );

    const recommendedDiv = (
      <RevertInput
        className={fieldWrapperClases.inputGroupDefault}
        value={defaultVal}
        enable={canRevert}
        onClick={revertInput}
      />
    );

    // const differs = defaultValue !== currentValue;
    const hasError = error.length > 0;

    const inputGroup = (
      <div className="input-group-append">
        <span className="input-group-text">{createHTMLMarkup(unit || '')}</span>
      </div>
    );

    return (
      <Col sm={6}>
        <div>
          <InputGroup>
            <Input
              type={type}
              step={step}
              value={value}
              readOnly={calculated}
              onChange={changeInput}
            />
            { branch(!_.isNil(unit), inputGroup, null) }
          </InputGroup>
          <div className={fieldWrapperClases.inputGroupColumn}>
            { branch(!(_.isNil(range[0]) || _.isNil(range[1])), rangeDiv, null) }
            { branch(!calculated, recommendedDiv, null) }
          </div>
          {/* <div style={{ display: 'none' }}>{value}</div> */}
          { branch(hasError, <div className={fieldWrapperClases.errorBlock}>Error: {error}</div>, null) }
        </div>
      </Col>
    );
  }
}

export default FieldTypeInput;



// WEBPACK FOOTER //
// ./src/components/FieldTypeInput/FieldTypeInput.js